import { Box } from '@radix-ui/themes';
import SolidButton from './shared/solid-button';

interface MockSignInWidgetProps {
  loading: boolean;
  onSignIn: () => void;
}

export default function MockSignInDialogButton({
  loading,
  onSignIn
}: MockSignInWidgetProps) {
  return (
    <Box width='360px'>
      <SolidButton
        loading={loading}
        onClick={onSignIn}
        style={{ width: '100%' }}
      >
        Авторизоваться
      </SolidButton>
    </Box>
  );
}
